import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
// eslint-disable-next-line import/extensions
import { connect } from 'redux-zero/react';
import { FormattedMessage, injectIntl } from 'react-intl';

import { withLocaleContext } from '../../../locales/locale-context.js';
import { actions } from '../../../shared/store.js';
import PageHeader from '../../../components/page-header/page-header.component.js';
import NewsService from './news.service.js';
import { PrimaryButton } from '../../../components/ui-toolkit/buttons.js';
import NewsGrid from './news-grid.component';
import NotImplemented from '../../../components/not-implemented/not-implemented.js';

import './../news-events.scss';

const limitNewsByRequest = 10;

class NewsPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			clicked: 'News'
		};
	}

	static prefetchNews = (language, skip = 0) =>
		NewsService.getNews({ language, limit: limitNewsByRequest, skip });
	state = {
		hasError: false
	};

	componentDidMount() {
		const { news, setLoading } = this.props;
		if (!news) {
			this.fetchData();
		} else {
			setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		const {
			localeContext: { locale }
		} = this.props;

		if (prevProps.localeContext.locale.value !== locale.value) {
			this.fetchData();
		}
	}

	loadMoreNews = () => {
		const { news } = this.props;
		this.fetchData(news.length);
	};

	fetchData(skip = 0) {
		const {
			setLoading,
			setNews,
			setTotalNews,
			news,
			localeContext: { locale }
		} = this.props;

		if (news === null) {
			setLoading(true);
		}

		NewsPage.prefetchNews(locale.value, skip)
			.then(({ data, total }) => {
				if (news !== null && skip !== 0) {
					const oldNews = Array.from(news);
					setNews(oldNews.concat(data));
				} else {
					setNews(data);
				}
				setTotalNews(total);
				setLoading(false);
			})
			.catch(() => {
				setLoading(false);
				this.setState({
					hasError: true
				});
			});
	}

	render() {
		const { hasError } = this.state;
		const { news, totalNews, intl } = this.props;

		if (hasError) {
			return <NotImplemented />;
		}

		return (
			<div className="news-events-page">
				<Helmet>
					<title>
						{intl.formatMessage({
							id: 'navigation.news_events'
						})}
					</title>
				</Helmet>
				<section className="header">
					<div className="tab-container">
						<div className="container container-fluid">
							<div className="row tab-switcher">
								<PrimaryButton link={`/news`} extraClasses="current">
									<FormattedMessage id="navigation.news" />
								</PrimaryButton>
								<PrimaryButton link={`/events`}>
									<FormattedMessage id="navigation.events" />
								</PrimaryButton>
							</div>
						</div>
					</div>
					<div className="container container-fluid">
						<div className="row center-md">
							<div className="col-xs-12 col-md-12 center-xs center-md">
								<PageHeader title={<FormattedMessage id="news.page_name" />} />
							</div>
							<div className="col-xs-12 col-md-6 center-xs center-md">
								<h2>
									<FormattedMessage id="news.title" />
								</h2>
							</div>
						</div>
					</div>
				</section>
				<section className="news-section">
					{news && (
						<NewsGrid
							news={news}
							loadMore={news.length < totalNews}
							handleMore={this.loadMoreNews}
						/>
					)}
				</section>
			</div>
		);
	}
}

const mapToProps = ({ news, totalNews }) => ({
	news,
	totalNews
});

export default withLocaleContext(
	injectIntl(connect(mapToProps, actions)(NewsPage))
);

export { NewsPage };
